import type { ReactNode } from 'react';

export const symbol_iron: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-300h480v-160H240q-42 0-71 29t-29 71v60Zm480 0v-160 160Zm230-420q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5-21.25 0-35.62 14.37Q800-631.25 800-610v170q0 48-35.5 79T680-330v60q0 12.75-8.62 21.37Q662.75-240 650-240H110q-12.75 0-21.37-8.63Q80-257.25 80-270v-90q0-66 47-113t113-47h380v-49.82q0-21.18-14.37-35.68Q591.25-620 570-620H391q-11 0-19.5 3.5T356-606q-5 5-10 7.5t-12 2.5q-13.17 0-22.09-8.91Q303-613.83 303-627q0-7 2.5-12t7.5-10q15-14 34.6-22.5 19.61-8.5 42.4-8.5h180q45.83 0 77.92 32.08Q680-615.83 680-570v180q23 0 41.5-13.5T740-440v-170q0-45.83 32.08-77.92Q804.17-720 850-720Z"
		/>
	</svg>
);
